import React from 'react'

export default function MenuSvg() {
  return (
    <div>
        
        <svg fill='currentColor' width={'34px'} hanging={'34px'} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 422.207 422.207" style={{enableBackground:"new 0 0 422.207 422.207"}} xmlSpace="preserve">
     <path id="XMLID_111_" d="M298.427,117.237V19.158c0-4.418,3.582-8,8-8s8,3.582,8,8v98.079c0,4.418-3.582,8-8,8
       S298.427,121.655,298.427,117.237z M276.297,125.237c4.418,0,8-3.582,8-8V19.158c0-4.418-3.582-8-8-8s-8,3.582-8,8v98.079
       C268.297,121.655,271.879,125.237,276.297,125.237z M115.064,199.946c0-4.418-3.582-8-8-8H8c-3.236,0-6.153,1.949-7.391,4.938
       s-0.554,6.43,1.734,8.718L83.96,287.22c1.562,1.562,3.609,2.343,5.657,2.343s4.095-0.781,5.657-2.343
       c3.125-3.124,3.125-8.189,0-11.313l-67.96-67.96h79.75C111.482,207.946,115.064,204.365,115.064,199.946z M162.868,251.808v133.844
       c0,14.004-11.394,25.397-25.398,25.397c-14.003,0-25.396-11.393-25.396-25.397V251.808c0-11.209,7.3-20.747,17.396-24.106v-65.584
       c-30.365-4.819-53.897-36.69-53.897-75.165c0-41.794,27.767-75.795,61.897-75.795c34.131,0,61.898,34.001,61.898,75.795
       c0,38.475-23.532,70.346-53.898,75.165v65.584C155.568,231.06,162.868,240.597,162.868,251.808z M137.47,146.748
       c25.308,0,45.898-26.824,45.898-59.795s-20.59-59.795-45.898-59.795c-25.308,0-45.897,26.824-45.897,59.795
       S112.162,146.748,137.47,146.748z M146.868,251.808c0-5.181-4.216-9.396-9.398-9.396c-5.181,0-9.396,4.215-9.396,9.396v133.844
       c0,5.182,4.215,9.397,9.396,9.397c5.182,0,9.398-4.216,9.398-9.397V251.808z M421.598,196.885c-1.238-2.989-4.155-4.938-7.391-4.938
       h-97.19c-4.418,0-8,3.582-8,8s3.582,8,8,8h77.877l-64.682,64.681c-3.124,3.124-3.124,8.189,0,11.313
       c1.563,1.562,3.61,2.343,5.657,2.343c2.048,0,4.095-0.781,5.657-2.343l78.338-78.338
       C422.153,203.315,422.836,199.874,421.598,196.885z M316.76,251.808v133.844c0,14.004-11.394,25.397-25.398,25.397
       c-14.004,0-25.396-11.393-25.396-25.397V251.808c0-11.209,7.301-20.747,17.396-24.106v-65.553
       c-25.552-3.869-45.196-25.981-45.196-52.596V19.158c0-4.418,3.582-8,8-8s8,3.582,8,8v90.395c0,20.471,16.624,37.133,37.081,37.196
       c0.076-0.001,0.154-0.001,0.23,0c20.457-0.063,37.082-16.725,37.082-37.196V19.158c0-4.418,3.582-8,8-8s8,3.582,8,8v90.395
       c0,26.615-19.645,48.727-45.197,52.596v65.553C309.459,231.06,316.76,240.597,316.76,251.808z M300.76,251.808
       c0-5.181-4.216-9.396-9.398-9.396c-5.182,0-9.396,4.215-9.396,9.396v133.844c0,5.182,4.215,9.397,9.396,9.397
       c5.183,0,9.398-4.216,9.398-9.397V251.808z M242.429,360.409l-31.325,31.327l-23.331-23.331c-3.124-3.124-8.189-3.124-11.314,0
       c-3.124,3.124-3.124,8.189,0,11.313l28.988,28.987c1.5,1.5,3.535,2.343,5.657,2.343c2.122,0,4.156-0.843,5.657-2.343l36.981-36.983
       c3.124-3.125,3.124-8.189-0.001-11.314C250.618,357.284,245.553,357.286,242.429,360.409z M269.756,199.948c0-4.418-3.582-8-8-8
       H168.01c-4.418,0-8,3.582-8,8s3.582,8,8,8h93.747C266.174,207.948,269.756,204.367,269.756,199.948z"/>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     <g>
     </g>
     </svg>
     
    </div>
  )
}
